import React, { ReactNode, useEffect, useState } from 'react';

import { fetchCompanyUserProfile, fetchTenantUserProfile } from './ProfileFetcher';
import { SharedAuthContext } from './SharedAuthContext';
import { CompanyUserProfile } from './types/CompanyUserProfile';
import { SharedUserProfile } from './types/SharedUserProfile';
import { TenantUserProfile } from './types/TenantUserProfile';

export const SharedAuthProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [profile, setProfile] = useState<SharedUserProfile | undefined>(undefined);
  const [tenantProfile, setTenantProfile] = useState<TenantUserProfile>();
  const [companyProfile, setCompanyProfile] = useState<CompanyUserProfile>();
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchProfiles = async () => {
      setIsLoading(true);
      await Promise.all([
        fetchTenantUserProfile(setTenantProfile),
        fetchCompanyUserProfile(setCompanyProfile),
      ]);
      setIsLoading(false);
    };

    fetchProfiles();
  }, []);

  useEffect(() => {
    const isTenant = !!tenantProfile?.isLogin;
    setProfile({
      isTenant,
      tenantProfile: isTenant ? tenantProfile : undefined,
      companyProfile: !isTenant ? companyProfile : undefined,
    });
  }, [tenantProfile, companyProfile]);

  return (
    <SharedAuthContext.Provider value={{ profile, setProfile, isLoading }}>
      {children}
    </SharedAuthContext.Provider>
  );
};
